import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
} from '@angular/core'

import { environment } from 'src/environments/environment'
import { Subscription } from 'rxjs'

import { OwlOptions } from 'ngx-owl-carousel-o'
import { MatDialog } from '@angular/material/dialog'

import { TranslateService } from '@ngx-translate/core'
import { SliderUploaderComponent } from '../slider-uploader/product-slider-uploader.component'
import { ImageUpload } from 'src/app/shared/models/general.models'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { ProductsService } from '../../services/products.service'

@Component({
	selector: 'app-products-slider',
	templateUrl: './products-slider.component.html',
	styleUrls: ['./products-slider.component.scss'],
})
export class ProductsSliderComponent implements OnInit {
	@Input() ProductData!: any
	@Output() updateData: EventEmitter<any> = new EventEmitter()
	@Output() deleteImgUrl: EventEmitter<any> = new EventEmitter()
	@Output() mainImage: EventEmitter<any> = new EventEmitter()
	@Input() mainImageDisplay!: string
	@Input() smallSize: boolean = false
	@Input() mainProductSlider: boolean = false
	Subscription = new Subscription()
	attachmentUrl = environment.attachmentPath

	mobileConfig: ImageUpload = {
		imageCropDimensions: 2 / 1,
		imageWidth: 500,
		imageHeight: 500,
	}
	openMenu = false
	newUploadedImage: { url: string } = {
		url: '',
	}

	constructor(
		private dialog: MatDialog,
		private ProductsService: ProductsService,
		private translate: TranslateService
	) {}

	ngOnInit(): void {}

	uploadSliderImage(mainImage: boolean): void {
		this.mobileConfig.imageCropDimensions = mainImage ? 1 / 1 : 2 / 1
		const dialogRef = this.dialog.open(SliderUploaderComponent, {
			width: '752px',
			height: '450px',

			data: { mobile: this.mobileConfig },
		})
		dialogRef.afterClosed().subscribe((result: any) => {
			if (result) {
				this.uploadImage(result.selectedFile, mainImage)
			}
		})
	}

	uploadImage(file: { croppedMobile: File }, mainImage: boolean) {
		const formData = new FormData()
		formData.append('image', file.croppedMobile)
		this.Subscription.add(
			this.ProductsService.uploadProductPhoto(formData).subscribe(
				(response: any) => {
					let img = {
						id: 0,
						imageUrl: response.result.url,
					}

					if (!mainImage) {
						this.ProductData.push(img)
						this.updateData.emit(this.ProductData)
					} else {
						this.mainImage.emit(response.result.url)
						this.mainImageDisplay = response.result.url
					}
				}
			)
		)
	}
	handleBeforSave(isDelete: boolean, index: number = -1) {
		let images: any[] = []
		if (isDelete) {
			this.dialog
				.open(ConfirmationMessageComponent, {
					width: '585px',
					data: {
						image: 'assets/images/correct.svg',
						flex: true,

						message: this.translate.instant(
							'CONFIRMATION_MESSAGE.DELETE_IMAGE',
							{
								name: this.ProductData?.name,
							}
						),

						cancelBtn: 'ACTIONS.NO',
						confirmBtn: 'ACTIONS.YES',
					},
				})
				.afterClosed()
				.subscribe({
					next: (res) => {
						if (res) {
							images = [...this.ProductData.sliderImages]
							images.splice(index, 1)
							this.updateImage(images)
						}
					},
				})
		} else {
			images = [{ ...this.newUploadedImage }, ...this.ProductData.sliderImages]
			this.updateImage(images)
		}
	}

	updateImage(images: any) {
		const body = {
			id: this.ProductData?.id,
			tenantId: this.ProductData.tenantId,
			sliderUrls: images,
		}
	}
	deleteImg(image: any) {
		this.deleteImgUrl.emit(image)
		this.ProductData = this.ProductData.filter((ele: any) => ele !== image)
	}
}
